import leondraPic from "@/public/images/artists/leondra.png";
import { Artist } from "@/types/types";

export const leondra = {
  id: "162",
  name: "Leondra",
  image: leondraPic,
  description: `Leondra's voice is bold and resonant, with a naturally deep, slightly raspy timbre. She maintains a strong midrange presence, delivering her lyrics with a raw, assertive tone that blends grit with clarity. Her phrasing carries a distinct rhythmic drive, which adds a percussive edge to her delivery.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fleondra-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Female",
    tags: {
      primary: ["Hip Hop", "RnB", "Deep"],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "Low",
        high: "Low",
      },
      specific: {
        low: 57,
        high: 65,
      },
      sweetSpot: 60,
    },
  },
} as const satisfies Artist;
